import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const ClosedEyeIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.53052 3.75098L19.5335 20.2542" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5532 14.7777C13.8649 15.4082 12.9643 15.7564 12.0309 15.7528C11.2738 15.7528 10.5345 15.5236 9.91019 15.0955C9.28584 14.6674 8.80564 14.0604 8.53273 13.3543C8.25982 12.6481 8.20696 11.876 8.38112 11.1392C8.55527 10.4025 8.94828 9.73574 9.50848 9.22656" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.97226 6.43262C3.14651 8.36425 1.53369 12.0025 1.53369 12.0025C1.53369 12.0025 4.53428 18.7538 12.0358 18.7538C13.7935 18.7681 15.5293 18.3631 17.0992 17.5723" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.5898 15.8557C21.634 14.0272 22.5341 12.0018 22.5341 12.0018C22.5341 12.0018 19.5335 5.25051 12.0321 5.25051C11.3817 5.24923 10.7325 5.30255 10.0911 5.40992" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.7405 8.31738C13.5381 8.46851 14.265 8.87499 14.8113 9.47547C15.3577 10.0759 15.6939 10.8378 15.7692 11.6462" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(ClosedEyeIcon);
